import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-online-casino-solution',
  templateUrl: './online-casino-solution.component.html',
  styleUrls: ['./online-casino-solution.component.css']
})
export class OnlineCasinoSolutionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/online-casino-solution/online-casino-solution.component.ts